import { apiRequest } from "../../index";

import config from "../../../../config";
import logger from "../../../../logger";

const { VCHAT_API } = config;
const api = `${VCHAT_API}/recs`;

export async function getUserRecs({ creator, classroomId }) {
  try {
    const response = await apiRequest(`${api}/${creator}/${classroomId}`, "GET");
    return response;
  } catch (err) {
    throw err;
  }
}
export async function getMeetingRecs({ meetingId, meetingCreator }) {
  try {
    const response = await apiRequest(
      `${api}/meetingRecs/${meetingId}/${meetingCreator}`,
      "GET",
    );
    return response;
  } catch (err) {
    logger.info(`Error in getMeetingRecs: ${err}`);
    throw err;
  }
}
export async function getSubmissionsRecs({ meetingCreator, classroom }) {
  try {
    const response = await apiRequest(
      `${api}/submissions/${meetingCreator}/${classroom}`,
      "GET",
    );
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getRec({ extMeetingId, s3Path, meetingCreator }) {
  try {
    const response = await apiRequest(
      `${api}/url/${extMeetingId}/${s3Path}/${meetingCreator}`,
      "GET",
    );
    return response;
  } catch (err) {
    throw err;
  }
}
export async function getRecEvents({
  meetingCreator,
  recCreator,
  meetingId,
  prefix = "",
  extMeetingId,
}) {
  try {
    const response = await apiRequest(
      `${api}/${recCreator}/${meetingCreator}/${meetingId}/${prefix}/${extMeetingId}`,
      "GET",
    );
    return response;
  } catch (err) {
    throw err;
  }
}
export async function updateRec({
  userId,
  creator,
  meetingId,
  extMeetingId,
  values,
}) {
  try {
    const response = await apiRequest(
      `${api}/${userId}/${creator}/${meetingId}/${extMeetingId}`,
      "PATCH",
      values,
    );
    return response;
  } catch (err) {
    throw err;
  }
}
export async function deletePipeline({ mediaPipelineId }) {
  try {
    const response = await apiRequest(`${api}/${mediaPipelineId}`, "DELETE");
    return response;
  } catch (err) {
    throw err;
  }
}
export async function createRec(body) {
  try {
    const response = await apiRequest(`${api}`, "POST", body);
    return response;
  } catch (err) {
    throw err;
  }
}
export async function saveRec(body) {
  try {
    const response = await apiRequest(`${api}/save`, "POST", body);
    return response;
  } catch (err) {
    throw err;
  }
}
export async function concatRec(body) {
  try {
    const response = await apiRequest(`${api}`, "POST", body);
    return response;
  } catch (err) {
    throw err;
  }
}
